import { Link } from '@tanstack/react-router'
import { Brandlock } from './Brandlock'
import { Container } from './Container'

/**
 * The chrome a SHARE page wears: the club's mark, and one quiet way in.
 *
 * ## Why this exists at all, rather than reusing `ClubHeader`
 *
 * `ClubHeader` spends the club's ONE flag CTA on **Apply**. The share page's
 * flag belongs to the join rail at its foot — the thing a stranger who just
 * read somebody's round is actually being asked to do — and the club allows one
 * hot accent per page. Two Applies on one page would be the club shouting, and
 * dropping the foot's rail instead would put the ask above the round rather
 * than after it. So the share chrome carries **no CTA at all**.
 *
 * ## And no member nav, and no session read
 *
 * The reader holds a link, not a membership: offering "The Clubhouse" and "Your
 * account" to someone with neither is furniture that answers nothing. More
 * importantly this component — and every other thing `chrome="share"` renders —
 * touches NO auth context. A public archive page that asked the server who is
 * reading it would be a session read nobody asked for on a page the whole
 * internet can open, and it is pinned by `sharedRound.test.tsx`, which renders
 * the screen with no `AuthProvider` at all (`useAuth` throws without one).
 *
 * The quiet link is a text link in fairway green, underlined — never a button
 * and never the flag. It goes home, which is where a stranger who liked what
 * they just read finds out what the club is.
 */
export function ShareMasthead() {
  return (
    <header className="border-b border-brass/35 bg-paper">
      <Container className="flex flex-wrap items-center justify-between gap-x-8 gap-y-3 py-3.5">
        <Brandlock />

        <Link
          to="/"
          className="rounded-club-sm text-[13.5px] text-fairway underline underline-offset-[3px]"
        >
          The club
        </Link>
      </Container>
    </header>
  )
}
